import { Credentials } from "auth";
import { Organization } from "generated/graphql";
import { Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";
import { State } from "redux/state";

export type CreateOrganization = "CREATE_ORGANIZATION";
export const CREATE_ORGANIZATION: CreateOrganization = "CREATE_ORGANIZATION";
export type CreateOrganizationEnd = "CREATE_ORGANIZATION_END";
export const CREATE_ORGANIZATION_END: CreateOrganizationEnd = "CREATE_ORGANIZATION_END";

export interface CreateOrganizationAction extends Action {
    payload: {
        credentials: Credentials;
        organization: Organization;
        redirectOnSuccess?: string;
    };
    type: CreateOrganization;
}

export function createOrganization(
    organization: Organization,
    redirectOnSuccess?: string
): ThunkAction<void, State, undefined, CreateOrganizationAction> {
    return (dispatch: Dispatch<CreateOrganizationAction>, getState) => {
        const state = getState();
        dispatch(createOrganizationWithCreds(state.auth.credentials, organization, redirectOnSuccess));
    };
}

function createOrganizationWithCreds(
    credentials: Credentials,
    organization: Organization,
    redirectOnSuccess?: string
): CreateOrganizationAction {
    return {
        payload: {
            credentials,
            organization,
            redirectOnSuccess
        },
        type: CREATE_ORGANIZATION
    };
}

export interface CreateOrganizationEndAction extends Action {
    payload: {
        organization?: Organization;
        error?: Error;
        selectOnSuccess?: boolean;
    };
    type: CreateOrganizationEnd;
}

export function createOrganizationEnd(
    error: Error,
    organization?: Organization,
    selectOnSuccess?: boolean
): CreateOrganizationEndAction {
    return {
        payload: {
            error,
            organization,
            selectOnSuccess
        },
        type: CREATE_ORGANIZATION_END
    };
}
